
import { CommandBarButton, DefaultButton, IButtonProps, Text } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { Badge } from 'primereact/badge';
import { icon } from '@fortawesome/fontawesome-svg-core';

export interface CustomCommandBarButtonProps {
    asDefaultButton?: any,
    badge?: any,
    iconPropsFontAwesome?: any
    iconPropsIcoMoon?: any
    className?: string
}

type Props = CustomCommandBarButtonProps & RouteComponentProps & IButtonProps

const CustomCommandBarButton: React.FunctionComponent<Props> = props => {


    const onRenderIcon = (item, defaultRenderer) => {

        let iconStyle = {};
        //faccio il merge degli stili
        item.styles.icon.map(it => iconStyle = { ...iconStyle, ...it })


        if (item.iconPropsFontAwesome) {
            // se ho impostato l'icona di fontawsome 
            return (

                <React.Fragment>
                    <FontAwesomeIcon style={iconStyle} {...item.iconPropsFontAwesome} />
                </React.Fragment>
            );
        }
        else if (item.iconPropsIcoMoon) {
            // se ho impostato l'icona di icomoon 
            return (

                <React.Fragment>
                    <span style={{ ...iconStyle, color: item.disabled ? 'rgb(161, 159, 157)' : iconStyle['color'] }} {...item.iconPropsIcoMoon}></span>

                </React.Fragment>
            );
        }
        else {
            // altrimenti mostro l'icona di fluentui
            return (

                <React.Fragment>
                    {defaultRenderer(item)}
                </React.Fragment>
            );
        }
    }
    const onRenderText = (item, defaultRenderer) => {

        const textStyles = {
            color: item.disabled ? 'rgb(161, 159, 157)' : 'inherit'
        };

        return (

            <React.Fragment>
                {item.badge ?
                    // se ho impostato un badge lo mostro
                    <React.Fragment>
                        <div className="mr-3">
                            <div className="p-overlay-badge">
                                <Text style={textStyles} className="px-2">{item.text}</Text>
                                <Badge value={item.badge} className="ml-2"></Badge>
                            </div>
                        </div>

                    </React.Fragment> :
                    // altrimenti il render di default
                    <Text style={textStyles} className="px-2">{item.text}</Text>
                }
            </React.Fragment>
        );
    }
    if (props.asDefaultButton) {
        return (
            <DefaultButton
                {...props}
                primary
                styles={{ icon: {} }}
                className={props.className ? props.className : ''}
                onRenderIcon={onRenderIcon}
                iconProps={props.iconProps}
            />
        );
    }
    else {
        return (
            <CommandBarButton
                {...props}
                className={props.className ? props.className : ''}
                onRenderText={onRenderText}
                onRenderIcon={onRenderIcon}
                iconProps={props.iconProps}
            />
        );
    }
};


export default withRouter(CustomCommandBarButton);